export const supportedLocales = ['en', 'en-CA', 'fr-CA'];
